export default "__VITE_ASSET__DxVotnDz__"